<template>
  <GModal ref="modalStore" class="modal--store">
    <div slot="header">
      <button type="button" class="close" aria-label="Close">
        <img src="/assets/img/icons/close-modal.svg" alt="SOCO" @click.prevent="closeModal" />
      </button>

      <h2 class="modal-heading">Available At Store</h2>
    </div>

    <div slot="body">
      <div class="input-search">
        <input
          v-model="offlineStore"
          :disabled="loadingStore"
          type="text"
          placeholder="Enter area, city, or building (e.g. Jakarta Barat)"
        />
      </div>

      <div class="row">
        <template v-if="loadingStore">
          <div class="col-md-12 col-xs-12 element-placeholder elm-placeholder">
            <div class="left col-md-4 col-xs-5 pl-0">
              <figure class="placeholder" style="height: 90px; width: 100%" />
            </div>
            <div class="right col-md-8 col-xs-7 pr-0 pl-0">
              <figure class="placeholder" style="height: 90px; width: 100%" />
            </div>
          </div>
        </template>
        <template v-else>
          <div v-for="(store, index) in listOfStore" :key="index" class="store-list col-md-12 col-xs-12">
            <div class="left col-md-4 col-xs-5">
              <img :src="store.image" onerror="this.src='/assets/img/dummy_product.svg'" width="135" height="90" />
            </div>
            <div class="right col-md-8 col-xs-7">
              <p class="store-title">{{ store.name }}</p>
              <p class="store-address">{{ store.address }}</p>
              <p v-if="store.information && store.information.day_open" class="store-calender">
                <SvgImg id="calender" name="calender" width="16" height="14" /><span>{{
                  store.information.day_open
                }}</span>
              </p>
              <p v-if="store.information && store.information.time_open" class="store-time">
                <SvgImg id="time" name="time" width="16" height="14" /><span>{{ store.information.time_open }}</span>
              </p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </GModal>
</template>

<script>
const Config = require('~/config/default.env').default;

export default {
  name: 'modal-store',
  data() {
    return {
      offlineStore: '',
      loadingStore: false,
      listStore: [],
    };
  },
  computed: {
    listOfStore() {
      const store = this.listStore;
      if (this.offlineStore.length > 2) {
        return store.filter((store) => {
          return this.offlineStore
            .toLowerCase()
            .split(' ')
            .every((v) => store.name.toLowerCase().includes(v) || store.address.toLowerCase().includes(v));
        });
      } else {
        return store;
      }
    },
  },
  created() {
    const storeId = this.$store.state.productDetail.storeId;
    if (storeId.length) {
      this.getStore(storeId);
    }
  },
  methods: {
    closeModal() {
      this.$store.commit('setModalStore', { show: false });
      document.documentElement.style.overflow = '';
    },
    getStore(storeId) {
      this.listStore = [];
      this.loadingStore = true;
      axios
        .get(Config.MS_POS_API_URL + '/stores', {
          params: { filter: { _id: { $in: storeId } } },
        })
        .then((res) => {
          if (res.status === 200 && res.data && res.data.data) {
            this.listStore = [...res.data.data];
            document.documentElement.style.overflow = 'hidden';
          }
          this.loadingStore = false;
        })
        .catch((error) => {
          this.loadingStore = false;
        });
    },
  },
};
</script>
